import $ from "jquery";

$(function () {
    $(".bl-parallaximage").each(function () {
        initBlock($(this));
    });
});

function initBlock($bl) {
    const bl = $bl.get(0);

    const container = bl.querySelector(".ctrimage");
    const parallaxImage = container.querySelector("img");
    const speed = 2;

    function updateParallax() {
        const rect = container.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Check if in viewport
        if (rect.bottom > 0 && rect.top < windowHeight) {
            // Progress from 0 → 1
            const progress = (windowHeight - rect.top) / (windowHeight + rect.height);

            const translateY = (progress - 0.5) * speed * 100;
            parallaxImage.style.transform = `translateY(calc(-33% + ${translateY}px))`;
        }
    }

    let rafParallax = null;
    function requestUpdateParallax() {
        cancelAnimationFrame(rafParallax);
        rafParallax = requestAnimationFrame(updateParallax);
    }

    window.addEventListener("scroll", requestUpdateParallax, { passive: true });
    window.addEventListener("resize", requestUpdateParallax);
    requestUpdateParallax();
}
